import * as types from "../types/deliveries";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveDeliveries,
  createNewDelivery,
} from "../../networking/deliveries/networking";

function* fetchDeliveriesListings(action) {
  try {
    if (action.payload) {
      const deliveries = yield call(retrieveDeliveries, action.payload);
      if (deliveries.error === null) {
        yield put({
          type: types.SET_DELIVERIES_LISTINGS,
          content: deliveries.payload,
        });
      } else {
        throw new Error("Kunne ikke hente filer");
      }
    } else {
      throw new Error("Kunne ikke hente filer");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELIVERIES_LISTINGS, message: e });
  }
}

function* performAddSingleDelivery(action) {
  try {
    if (action.details) {
      var response = yield call(createNewDelivery, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_SINGLE_DELIVERY });
        yield put({
          type: types.CHANGE_DELIVERIES_MODALS,
          modal: { newModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke legge til ny kunde.");
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_ADD_SINGLE_DELIVERY, message: error });
    yield put({
      type: types.CHANGE_DELIVERIES_MODALS,
      modal: { newModal: false },
    });
  }
}

function* detailsSaga() {
  yield all([
    takeEvery(types.REQUEST_DELIVERIES_LISTINGS, fetchDeliveriesListings),
    takeEvery(types.REQUEST_ADD_SINGLE_DELIVERY, performAddSingleDelivery),
  ]);
}

export default detailsSaga;
